import React from "react";
import { Stack, Breadcrumb, Pivot, PivotItem } from "office-ui-fabric-react";
import { useHistory, useParams } from "react-router-dom";
import { ICustomers } from "../../../vm";
import { getAllCustomers } from "../../../services/customers/CustomerService";
import { ToastContext } from "../../common/ToastProvider";
import { Loading } from "../../../services/Loading";
import PduPowerTable from "./PduPowerTable";
import MinimumCommitted from "./MinimumCommitted";
import { childrenGap8 } from "../../common/Constants";
import ReportConfiguration from "./ReportConfiguration";

export interface PowerUtilizationMainProps {}

const PowerUtilizationMain: React.FC<PowerUtilizationMainProps> = () => {
  //custom hooks
  const history = useHistory();
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);

  //state
  const [state, setState] = React.useState({
    isLoading: false,
    customer: {
      name: "",
    },
    selectedKey: "",
  } as {
    selectedKey: string;
    isLoading: boolean;
    customer: ICustomers;
  });

  React.useEffect(() => {
    let hash = window.location.hash;
    if (hash) {
      hash = hash.substr(1);
      setState({
        ...state,
        selectedKey: hash,
      });
    }
  }, [window.location.pathname]);

  React.useEffect(() => {
    const asyncFunc = async () => {
      await getACustomer();
    };
    asyncFunc();
  }, []);

  const getACustomer = async () => {
    setState({ ...state, isLoading: true });
    let result = await getAllCustomers({ customerId: params.customerId });
    if (result && result.success && result.data.length > 0) {
      setState({
        ...state,
        customer: result.data[0],
        isLoading: false,
      });
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result.message || "Error while getting customer details",
        "error"
      );
    }
  };

  const _getTabId = (itemKey: string): string => {
    return `${itemKey}`;
  };

  const handleCallToRouter = (value: any) => {
    setState({
      ...state,
      selectedKey: value.props.itemKey,
    });
    history.push(window.location.pathname + "#" + value.props.itemKey);
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      <Stack tokens={childrenGap8}>
        <Stack.Item>
          <Breadcrumb
            items={[
              {
                text: state.customer.name,
                key: "name",
                onClick: () => {
                  history.push(`/customers/${state.customer._id}`);
                },
              },
              {
                text: "Power Utilization",
                key: "power-utilization",
                isCurrentItem: true,
              },
            ]}
          />
        </Stack.Item>
        <Stack.Item>
          <Pivot
            onLinkClick={handleCallToRouter}
            getTabId={_getTabId}
            selectedKey={state.selectedKey}
          >
            <PivotItem
              itemKey="power-table"
              headerText="Power Utilization Table"
            >
              <PduPowerTable customerName={state.customer.name} />
            </PivotItem>
            <PivotItem
              itemKey="minimum-committed"
              headerText="Minimum Committed"
            >
              <MinimumCommitted />
            </PivotItem>
            <PivotItem
              itemKey="report-configuration"
              headerText="Report Configuration"
            >
              <ReportConfiguration isPdu={true} />
            </PivotItem>
          </Pivot>
        </Stack.Item>
      </Stack>
    </React.Fragment>
  );
};

export default PowerUtilizationMain;
